import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/favorites/favoriteShoppingList';
import dummyImage from 'public/img/ui/loading-dummy.gif';
import FavoriteShoppingListItemContainer from '@/containers/favorites/FavoriteShoppingListItemContainer';
import { IShopping } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  shoppingList: IShopping[];
  isLoading: boolean;
};

const FavoriteShoppingList: React.FC<ComponentProps> = ({ shoppingList, isLoading }) => {
  const classes = useStyles();
  const renderContent = () => {
    if (isLoading) {
      return (
        <p className={classes.textWrapper}>
          <img src={dummyImage} alt='ローディング中' className={classes.imgLoading} />
        </p>
      );
    } else if (!isLoading && shoppingList.length === 0) {
      return <p className={classes.textWrapper}>アイテムをお気に入り登録しましょう</p>;
    } else {
      return (
        <GridContainer>
          {shoppingList.map((item, index) => {
            return (
              <FavoriteShoppingListItemContainer
                shopping={item}
                key={`favorite-item-${index.toString()}`}
              />
            );
          })}
        </GridContainer>
      );
    }
  };

  return <div className={classes.section}>{renderContent()}</div>;
};

export default FavoriteShoppingList;
